import React from 'react'
import { Review } from '../../types'
import { useTranslation } from 'react-i18next'
import { FaStar } from 'react-icons/fa'

const Reviews = ({ reviews }: { reviews: Review[]|[] }) => {
    const { t } = useTranslation()
    return (
        <div>
            <h2 className="text-2xl font-semibold mb-4">{t("reviews")} ({reviews.length})</h2>
            <div className="space-y-6">
                {reviews.length === 0 && <div className=" text-textSecond">{t("no-reviews")}</div>}
                {reviews.map((review) => (
                    <div key={review.id} className="border rounded-lg p-4">
                        <div className=' flex justify-between  items-start'>
                            <div className="flex items-center gap-3 mb-2">
                                <div className='w-10 h-10 rounded-full overflow-hidden '>
                                    <img
                                        src={review.userImage ? review.userImage : "/asset/pp.svg"}
                                        alt={review.userName}
                                        className=" w-full object-cover"
                                    />
                                </div>

                                <div>
                                    <div>
                                        <p className="font-semibold">{review.userName}</p>
                                        <p className="text-sm text-textSecond">
                                            {new Date(review.createAt).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <p className="text-secondry mb-1  flex  items-center gap-1"><FaStar /> {review.rating}</p>
                        </div>
                        <p className="text-textSecond">{review.comment}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Reviews